import { CREDIT_CARD_PAYMENT_METHOD } from 'src/comps/PaymentForm/constants'

const transformPaymentMethodData = paymentMethod => {
  if (paymentMethod === 'applePay') return 'apple_pay'
  return paymentMethod
}

const mapAdditionalProductsSelections = additionalProductsSelections => {
  return Object.entries(additionalProductsSelections).reduce(
    (accumulator, [typeId, availabilityIds]) => {
      accumulator[typeId] = availabilityIds.join(',')
      return accumulator
    },
    {}
  )
}

export function buildSummaryRequest({
  additionalProductsSelections,
  purchaseId,
  paymentMethod,
  insuranceIds = [],
  payNowIds = [],
}) {
  return {
    purchase_id: purchaseId,
    insurance_ids: insuranceIds.join(','),
    pay_now_ids: payNowIds.join(','),
    payment_provider:
      paymentMethod === CREDIT_CARD_PAYMENT_METHOD ? '' : transformPaymentMethodData(paymentMethod),
    ...(additionalProductsSelections && {
      additional_products: mapAdditionalProductsSelections(additionalProductsSelections),
    }),
  }
}
